<template>
	<div class="tpl send-edit-info-wrap">
		<mt-header title="填写信息" fixed>
		  <router-link :to="{name:'appointment-list'}" slot="left">
		    <mt-button icon="back"></mt-button>
		  </router-link>
		  <mt-button  slot="right" @click.native="submitAppoint()">发布</mt-button>
		</mt-header>
		<div class="edit-options">
			<ul>
				<li>
					<span class="option-name">约会时间</span>
					<span class="option-value" @click="openPicker"><span v-if="pickerValue==''">选择时间</span><span v-if="pickerValue!=''">{{pickerValue | convertTime("MM月DD日 HH时")}}</span><img src="../../assets/img/finds/ic_list_enter@2x.png" alt="" /></span>
				</li>
				<li>
					<span class="option-name">约会地点</span>
					<span class="option-value"><span v-if="address.area==''">地图选址</span><span v-if="address.area!=''">{{address.city}}{{address.area}}{{address.more}}</span></span>
				</li>
				<li>
					<div id="oe_map" style="height:10rem;"></div>
				</li>
				<li>
					<span class="option-name">约会人数</span>
					<span class="option-value">
						<span class="num-del" @click="num<=1?num=1:num--">-</span>
						<input type="number" v-model="num" min="1" />
						<span class="num-add" @click="num++">+</span>
					</span>
				</li>
				<li>
					<span class="option-name">约会对象</span>
					<span class="option-value sex-options">
						<span :class="{'active':sex==0}" @click="sex=0">不限</span>
						<span :class="{'active':sex==1}" @click="sex=1">男</span>
						<span :class="{'active':sex==2}" @click="sex=2">女</span>
					</span>
				</li>
				<li>
					<span class="option-name">消费类型</span>
					<span class="option-value sex-options">
						<span :class="{'active':type==0}" @click="type=0">AA</span>
						<span :class="{'active':type==1}" @click="type=1">我买单</span>
						<span :class="{'active':type==2}" @click="type=2">你买单</span>
					</span>
				</li>
				<li class="option-message">
					<span class="option-name">邀约寄语</span>
					<span class="option-value">
						<textarea v-model="message" placeholder="给你们的约会来句寄语吧~"></textarea>
					</span>
				</li>
				<li>
					<div class="upload-img">
						<img v-if="previewImgUrl==''" src="../../assets/img/finds/btn_text_picture@2x.png"/>
						<img :src="previewImgUrl"/>
						<input type="file" accept="image/*"  @change="uploads" ref="delPreview" name="img"/>
						<span v-if="previewImgUrl!=''" class="del-img" @click="delPreview"><img src="../../assets/img/finds/ic_sel_del@2x.png"/></span>
					</div>
				</li>
			</ul>
		</div>
		<mt-datetime-picker
		    ref="picker"
		    type="datetime"
		    v-model="pickerValue"
		    :startDate="startDate">
		</mt-datetime-picker>
	</div>
</template>

<script>
	
	export default{
		name:"send-edit-info",
		data(){
			return{
				uid:"",		//用户id
				theme:"",	//约会主题
				gifts:"",	//约会礼物列表
				pickerValue:"",	//约会时间
				address:{
					city:"",
					area:"",
					name:"",
					lng:"",
					lat:""
				},		
				addressDetail:"石路天虹",	//约会详细地址
				num:1,	//约会人数
				sex:0,		//约会对象性别
				type:0,	//消费类型
				preMoney:"",	//诚意金
				message:"",		//约会寄语
				startDate:new Date(),	//日期选择器开始时间设置
				previewImgUrl:"",
				formData:new FormData(),
			}
		},
		created(){
			this.theme = this.$route.params.theme;
			this.preMoney = this.$route.params.money;
			this.gifts = this.$route.params.gifts;
			
			
			this.uid = this.$store.state.UserId;	//获取当前用户的id
			this.$store.commit("changeTabChoosed","finds");		//属于finds模块
			this.$store.commit("changeTabBarShow",false);	//不显示navbar
			console.log(this.theme,this.preMoney,this.gifts)
		},
		mounted(){
			let _this = this;
			
			var OE_MAP_ZOOM = 16;
			var map_obj = "";
			var map_geoc = "";
			var map_point = "";
			var map_marker = "";
			var OE_MAP_LNG = "";
			var OE_MAP_LAT = "";
			var $_init_display_marker = false;
			
			function _initOEmap() {
				$_init_display_marker = false;
				if(typeof(OE_MAP_LNG) == "undefined") {
					OE_MAP_LNG = "";
				}
				if(typeof(OE_MAP_LAT) == "undefined") {
					OE_MAP_LAT = "";
				}
				if(OE_MAP_LNG.length == 0) {
					OE_MAP_LNG = 120.592727;
				} else {
					$_init_display_marker = true;
				}
				if(OE_MAP_LAT.length == 0) {
					OE_MAP_LAT = 31.306407;
				}
				map_obj = new BMap.Map("oe_map");
				map_geoc = new BMap.Geocoder();    
				map_point = new BMap.Point(OE_MAP_LNG, OE_MAP_LAT);
				map_obj.centerAndZoom(map_point, OE_MAP_ZOOM);
				map_obj.addControl(new BMap.NavigationControl());
				map_obj.addControl(new BMap.ScaleControl());
				map_obj.addControl(new BMap.OverviewMapControl());
				map_obj.enableScrollWheelZoom();
				map_obj.addControl(new BMap.MapTypeControl());
				if($_init_display_marker == true) {
					map_marker = new BMap.Marker(new BMap.Point(OE_MAP_LNG, OE_MAP_LAT));
					map_marker.enableDragging();
					map_obj.addOverlay(map_marker);
					map_marker.addEventListener("dragend", function(e) {
						getAddInfo(e.point);
					});
				}
				if(map_marker) {
					map_obj.addOverlay(map_marker);
					map_marker.enableDragging();
					map_marker.addEventListener("dragend", function(e) {
						getAddInfo(e.point);
					});
				}
				map_obj.addEventListener("click", function(e) {
					map_obj.clearOverlays();
					map_marker = new BMap.Marker(new BMap.Point(e.point.lng, e.point.lat));
					map_marker.enableDragging();
					map_obj.addOverlay(map_marker);
					getAddInfo(e.point);
					map_marker.addEventListener("dragend", function(e) {
						getAddInfo(e.point);
					});
				});
			}
			
			function getAddInfo(obj){
				console.log(obj)
				_this.address.lng = obj.lng;
				_this.address.lat = obj.lat;
				map_geoc.getLocation(obj, function(rs){
					var addComp = rs.addressComponents;
					_this.address.city = addComp.city;
					_this.address.area = addComp.district;
					_this.address.name = addComp.district+addComp.street+addComp.streetNumber;
				}); 
			}
			
			function _searchMap() {
				$_location_key = $("#maplocation").val();
				if($_location_key.length > 0) {
					map_obj.clearOverlays();
			
					function _getBDFirstMarker() {
						var pp = local.getResults().getPoi(0).point;
						map_obj.centerAndZoom(pp, OE_MAP_ZOOM);
						map_marker = new BMap.Marker(new BMap.Point(pp.lng, pp.lat));
						map_marker.enableDragging();
						map_obj.addOverlay(map_marker);
						getAddInfo(e.point);
						map_marker.addEventListener("dragend", function(e) {
							getAddInfo(e.point);
						});
					}
					var local = new BMap.LocalSearch(map_obj, {
						onSearchComplete: _getBDFirstMarker
					});
					local.search($_location_key);
				}
			}
			
			_initOEmap();
		},
		methods:{
			openPicker() {
		        this.$refs.picker.open();
		   	},
		  	uploads(e) {
				const file = e.target.files[0];
				let URL = window.URL || window.webkitURL; // 与上传没有关系（可选）
				this.previewImgUrl = URL.createObjectURL(file) // 这是为了显示图片而已， 与上传没有关系（可选）
				this.formData.append('img[]', file); // 'file[]' 代表数组 其中`file`是可变的
			},
			delPreview(){
				this.$refs.delPreview.value = "";
				this.previewImgUrl = "";
			},
			submitAppoint(){
//				this.$toast({
//					message: "为获取精确定位，请下载鱼水缘app后发布约会活动",
//					position: "bottom",
//					duration: 3000
//				});
//				return false;
				var gift = "";
				if(this.gifts){
					for(let i=0;i<this.gifts.length;i++){
						gift += this.gifts[i].g_id+","+this.gifts[i].num+",";
					}
					gift=(gift.substring(gift.length-1)==',')?gift.substring(0,gift.length-1):gift;
				}
				console.log(Date.parse(this.pickerValue));
//				return false;
				var time = Date.parse(this.pickerValue)/1000;
				console.log(gift);
				this.formData.append('uid', this.uid);
				this.formData.append('sincerity', this.theme.id);
				this.formData.append('other', this.theme.name);
				this.formData.append('release_time', time);
				this.formData.append('girl_friend', this.sex);
				this.formData.append('consumption_type', this.type);
				this.formData.append('earnest_money', this.preMoney);
				this.formData.append('Message', this.message);
				this.formData.append('gift', gift);
				this.formData.append('city', this.address.city);
				this.formData.append('area', this.address.area);
				this.formData.append('address', this.address.name);
				this.formData.append('address_name', this.address.name);
				this.formData.append('longitude', this.address.lng);
				this.formData.append('latitude', this.address.lat);
				this.formData.append('type', '1');
				
				console.log(this.formData.getAll("img[]"))
				
				let config = {
		          	headers:{'Content-Type':'multipart/form-data'}
		        };
				this.$axios.post("Appointment/Appointment",this.formData,config).then(res=>{
					console.log(res);
					if(res.data.code==200){
						this.$toast({
							message: res.data.msg,
							position: "bottom",
							duration: 3000
						});
//						this.$router.push({
//							name:"my-certification"
//						})
					}
				}).catch(err=>{
					console.log(err)
				})
			}
		}
	}
</script>

<style scoped>
	#oe_map{
		width: 100%;
	}
	>>>.anchorBL,>>>.anchorTR{
		display: none
	}	
	>>>.mint-button-text{
		color: #282828;
	}
	.send-edit-info-wrap{
		padding-top: 2.5rem;
		background: #fff;
	}
	.edit-options li{
		display: flex;
		justify-content: space-between;
		align-items: center;
		font-size: 1rem;
		color: #282828;
		border-bottom: 1px solid #f3f3f3;
		padding: 0.8rem 1rem;
	}
	.edit-options li .option-value{
		display: flex;
		justify-content: center;
		align-items: center;
		color: #7b7b7b;
	}
	.edit-options li .option-value img{
		width: 1.5rem;
	}
	.edit-options .option-value .num-add,
	.edit-options .option-value .num-del{
		width: 1.5rem;
		height: 1.5rem;
		border: 1px solid #5415F9;
		border-radius: 3px;
		text-align: center;
		font-size: 1.2rem;
		line-height: 1.5rem;
		font-weight: bold;
		color: #5415F9;
	}
	.edit-options .option-value.sex-options span{
		height: 1.5rem;
		border: 1px solid #5415F9;
		border-radius: 3px;
		text-align: center;
		font-size: 0.8rem;
		line-height: 1.5rem;
		color: #5415F9;
		padding: 0 0.5rem;
	}
	.edit-options .option-value.sex-options span:nth-of-type(2){
		margin: 0 1rem;
	}
	.edit-options .option-value .num-add:active,
	.edit-options .option-value .num-del:active,
	.edit-options .option-value.sex-options span.active{
		background: #e4d9fe;
	}
	.edit-options li .option-value input{
		width: 3rem;
		height: 1.6rem;
		outline: 0;
		border: 1px solid #5415F9;
		border-radius: 3px;
		text-align: center;
		font-size: 0.8rem;
		line-height: 1.6rem;
		margin: 0 1rem;
		color: #5415F9;
	}
	.edit-options li.option-message{
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
	}
	.edit-options li.option-message .option-value{
		padding: 0.5rem 1rem 0 1rem;
		width: 90%;
		display: block;
	}
	.edit-options li.option-message .option-value textarea{
		width: 100%;
		height: 4rem;
		max-width: 100%;
		min-width: 100%;
		max-height: 4rem;
		min-height: 4rem;
		font-size: 0.8rem;
		color: #7B7B7B;
		padding: 0.3rem;
		line-height: 1.5rem;
		border: 0;
		outline: 0;
	}
	.edit-options .upload-img{
		width: 6rem;
		height: 6rem;
		/*overflow: hidden;*/
		position: relative;
		display: flex;
		justify-content: center;
		align-items: center;
		background: #f3f3f3;
		border-radius: 5px;
	}
	.edit-options .upload-img img{
		width: 100%;
	}
	.edit-options .upload-img input{
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		opacity: 0;
	}
	.edit-options .upload-img .del-img{
		position: absolute;
		top: -0.5rem;
		right: -0.5rem;
	}
	.edit-options .upload-img .del-img img{
		width: 1.2rem;
	}
</style>


// WEBPACK FOOTER //
// src/components/Finds/SendEditInfo.vue